import { createApp } from 'vue'
import router from './router/index'
import Antd from 'ant-design-vue';
import App from './App.vue'
import store from './store/index'
import config from './methods/config.js'
import methods from './methods/methods.js'

import 'ant-design-vue/dist/antd.css';

import './assets/css/global.css'

const app = createApp(App)
app.config.globalProperties.$config = config;
app.config.globalProperties.$methods = methods
app.use(router)
app.use(store)
app.use(Antd).mount('#app')
